import { Map, List, fromJS } from 'immutable'

import { strings } from 'context/LanguageContext/strings'
import { actions } from 'modules/configuration/actions'

const initialState = Map({
    '7NOW_Web_Offline': false,
    SuiteMaxLength: 25,
    banner_carousel_duration: 7,
    basket_max_items_qty: 99,
    basket_order_limit: 15000,
    basket_unique_items_limit: 16,
    ccpa_content:
        "<font face='Palatino' size=4 style='font-weight:bold'>California Privacy Rights<br/><br/></font><font face='Palatino' size=4>California residents, <a style='color: rgb(16,127,98); font-weight:bold' href='https://reactweb-dev.termn.us/ccpa'>click here</a> to learn about your rights under the California Consumer Privacy Act.<br/></font>",
    company_id: '125',
    currency: 'USD',
    customer_card_name_length: 25,
    delivery_notes_length: 210,
    location_cache_time: 300,
    max_tip_amount: 3000,
    min_tip_amount: 50,
    order_feedback_length: 100,
    password_length: 20,
    phone_number: '1-808-944-2711',
    phone_number_length: 10,
    products_categories_cache_time: 300,
    show_ccpa: true,
    status_messages_global_duration: 5,
    store_eta_cache_time: 300,
    timeout: 30,
    us_privacy_url: `${strings.LINKS_canadaPrivacyPolicy}?app=true`,
    us_terms_url: `${strings.LINKS_TermsAndConditions}?app=true`,
    ca_terms_url: `${strings.LINKS_canadaTermsAndConditions}?app=true`,
    ca_privacy_url: `${strings.LINKS_canadaPrivacyPolicy}?app=true`,
    user_name_length: 42,
    refer_a_friend_enabled: false,
    user_signup_date_range: 10,
    item_substitution_values: Map([
        { value: strings.REMOVE, display: strings.removeFromOrder, default: true },
        {
            value: strings.CANCEL,
            display: strings.cancelEntireOrder,
        },
    ]),
    '7NOW_WEB_AUTH_KEY': '73fc29d41a27',

    enabled_age_restricted_products_web: true,
    show_ccprka: true,
    ccprka_content: strings.LINKS_ccprka,
    place_order_overview_delay: 8000,
    order_history_limit: 14,
    help_center_flags: [],
    referral_code_length: 6,
    search_terms: List([]),
    paypal_enabled: true,
    venmo_enabled: true,
    default_subscription_id: '',
    subscriptions_enabled: true,
    language: null,
})

export default (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case actions.GET_CONFIGURATION_SUCCESS: {
            return payload ? state.merge(fromJS(payload)) : state
        }

        default:
            return state
    }
}
